<!--  -->
<template>
  <div class="box">
    <img src="/static/img/inqbg1.png" alt="" class="banner">
    <ul>
       <li style="background-image:url(/static/img/rongyuxii.png)" @click="$router.push('/inquery?inqtype=ry')">
        <img src="/static/img/rongyu.png" style="margin-top: 48px;"/> <br/>
            企业信息查询
       </li> 
       <li style="background-image:url(/static/img/rongyuxii.png)" @click="$router.push('/inquery?inqtype=px')">
        <img src="/static/img/peixun.png" style="margin-top: 48px;"/> <br/>
            培训信息查询
       </li> 
       <li style="background-image:url(/static/img/rongyuxii.png)" @click="$router.push('/inquery?inqtype=kt')">
        <img src="/static/img/keti.png" style="margin-top: 48px;"/> <br/>
            课题信息查询
       </li> 
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  mounted: {},

  methods: {}
}

</script>
<style scoped>
.box {
    width:1300px;
    margin:auto;
}
.box .banner{
    width: 1300px;
height: 256px;
}
.box ul{
    display: flex;
    margin-top: 32px;
    margin-bottom: 250px;
}
.box ul li{
    display: inline-block;
   width: 424px;
height: 208px;
    font-size: 26px;
font-family: PingFang SC;
margin-left: 26px;
text-align: center;
letter-spacing: 4px;
cursor: pointer;
font-size: 22px;
color: #0E0F10;
line-height: 52px;
}
.box ul li:first-child{
    margin-left: 0px;
}
</style>